import { Instagram, ArrowUpRight } from "lucide-react";
import { INSTAGRAM } from "@/lib/site";
import { Reveal } from "./Reveal";

export const InstagramBlock = () => (
  <section className="relative bg-[#2E0F3E] py-24 md:py-32 overflow-hidden" data-testid="instagram-block">
    <div className="absolute inset-0 opacity-30" style={{ backgroundImage: "radial-gradient(circle at 80% 20%, rgba(212,175,55,.25), transparent 45%)" }} />
    <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10 items-center">
      <Reveal className="md:col-span-7">
        <p className="eyebrow mb-5">Follow the Journey</p>
        <h2 className="text-4xl sm:text-5xl font-medium leading-tight">
          Strategy, wins & wisdom — daily on <span className="gold-text italic">Instagram</span>.
        </h2>
        <p className="mt-6 text-white/70 text-base md:text-lg font-light max-w-xl">
          Tax tips, money moves, Academy announcements and behind-the-scenes from the B2R team.
        </p>
      </Reveal>
      <Reveal className="md:col-span-5 md:justify-self-end" delay={0.15}>
        <a href={INSTAGRAM.url} target="_blank" rel="noopener noreferrer" data-testid="instagram-follow-link"
          className="group lux-card lift flex items-center gap-5 p-6 pr-8">
          <span className="w-16 h-16 rounded-2xl bg-[#D4AF37] flex items-center justify-center">
            <Instagram className="w-8 h-8 text-black" />
          </span>
          <span>
            <span className="block text-xs tracking-[0.2em] uppercase text-white/50">Follow us</span>
            <span className="block text-2xl font-display mt-1">{INSTAGRAM.handle}</span>
          </span>
          <ArrowUpRight className="w-6 h-6 text-[#D4AF37] transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </a>
      </Reveal>
    </div>
  </section>
);
